import { render, staticRenderFns } from "./official-document-list.view.vue?vue&type=template&id=26718b2c&"
import script from "./official-document-list.view.vue?vue&type=script&lang=ts&"
export * from "./official-document-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports